var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "reviews-empty d-flex flex-column align-center",
      attrs: { "data-qa": "lpu_reviews_empty" },
    },
    [
      _c("img", {
        staticClass: "mb-4",
        attrs: {
          alt: _setup.tStatic("Отзывов нет"),
          width: "175",
          height: "148",
          src: "/static/_v1/pd/pictures/reviews-list/empty-reviews.svg",
          draggable: "false",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "reviews-empty__text text-body-1 text--text text-center",
          class: { "reviews-empty__text--mobile": _setup.isMobile },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_setup.tStatic("Еще нет отзывов")) +
              "\n    " +
              _vm._s(_setup.tStatic("о клинике")) +
              "\n    "
          ),
          _c("span", { staticClass: "text-subtitle-1" }, [
            _vm._v(_vm._s(_vm.lpuName)),
          ]),
          _vm._v(
            ".\n    " +
              _vm._s(_setup.tStatic("Ваш отзыв будет первым.")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showLeaveButton
        ? _c(_setup.ReviewsLeaveBtn, {
            staticClass: "mt-10",
            attrs: { "lpu-id": _vm.lpuId },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }